import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sosReleaseDetailsListApi } from '@/services/releaseServices';

const initialFilters = {
  page: 0,
  releaseName: '',
  jiraProjectIds: [],
  createdByIds: [],
  applicationIds: [],
  releaseStatusCodes: [1, 2],
  releaseDatesCodes: [1, 2],
  archiveStatusCodes: [1],
};

export const fetchFilteredReleases = createAsyncThunk(
  'releaseList/fetchReleases',
  async (filters, { dispatch }) => {
    try {
      const response = await sosReleaseDetailsListApi(filters);
      dispatch(addReleases(response.releaseManagementCardData || []));
      dispatch(updateReleasePageNumber(filters.page + 1));
    } catch (error) {
      console.error('Failed to load filtered releases:', error);
      throw error;
    }
  },
);

const releaseListSlice = createSlice({
  name: 'releaseList',
  initialState: { items: [], filters: initialFilters },
  reducers: {
    addReleases: (state, { payload }) => {
      state.items = payload;
    },
    addReleaseFilters: (state, { payload: { key, value } }) => {
      state.filters[key] = value;
      state.filters.page = 0;
    },
    clearReleaseFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload, page: 0 };
    },
    updateReleasePageNumber: (state, { payload }) => {
      state.filters.page = payload;
    },
  },
});

export const {
  addReleases,
  addReleaseFilters,
  clearReleaseFilters,
  updateReleasePageNumber,
} = releaseListSlice.actions;

export const releaseListFilterMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const result = next(action);
    if (addReleaseFilters.match(action) || clearReleaseFilters.match(action)) {
      return dispatch(fetchFilteredReleases(getState().releaseList.filters));
    }
    return result;
  };

export default releaseListSlice.reducer;
